import { createUseFeatureFlag } from '@montugroup/circuit-shared/hooks/featureFlags/createUseFeatureFlag';
import { useFeatureFlagsSelector } from './useFeatureFlagsSelector';

export const useFeatureFlag = createUseFeatureFlag(useFeatureFlagsSelector);
